import React, { memo, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { FormControlLabel, Switch } from '@mui/material';
import { makeStyles } from '@mui/styles';

import color from 'utils/constants/color';
import styled from 'styled-components';
import { debounce, find, get } from 'lodash';
import { styled as muiStyled } from '@mui/material/styles';
import usePopUpAtOnce from '../../../components/hooks/usePopUpAtOnce';
import { useAnswerView } from 'store/main_book_popup/selectors';
import { captureException } from '@sentry/react';
import SentryWrap from 'components/Sentry';
import { useLocation } from 'react-router-dom';
import useStoryViewOpen from '../../../components/hooks/useStoryViewOpen';

// import { Switch } from 'antd';

const Container = styled.div`
  // margin-top: 10px;
  // margin-bottom: 10px;
  // margin-bottom: 5px;
`;

const LinkContainer = styled.div`
  max-height: 300px;
  overflow: auto;
  margin-top: 10px;
  background-color: ${color.green100};
  padding: 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 11;
  top: 21px;
  left: 10px;
  &.fade-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 300ms,
      transform 300ms;
  }
  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }
  &.fade-exit-active {
    opacity: 0;
    transform: translateY(-10px);
    transition:
      opacity 300ms,
      transform 300ms;
  }
`;

const LinkItem = styled.div`
  margin-bottom: 5px;
  color: #fff;
  white-space: pre-line;
`;
const LinksItem = styled.a`
  color: #fff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  font-size: 14px;
  &:hover {
    color: ${color.white};
  }
  &:before {
    display: inline-block;
    content: '';
    -webkit-border-radius: 0.375rem;
    border-radius: 0.375rem;
    height: 0.55rem;
    width: 0.55rem;
    margin-right: 0.5rem;
    background-color: #fff;
  }
`;

const StyledFormControlLabel = muiStyled(FormControlLabel)(({ theme }) => ({
  margin: '5px',
  '& .MuiFormControlLabel-label': {
    textTransform: 'uppercase',
  },
  '&.teacher-stag': {
    margin: '5px',
  },
}));

const useStyles = makeStyles({
  root: {
    margin: '5px',
    width: '175px',
  },
  sizeSmall: {
    width: '50px',
    height: '25px',
  },
  checkedSwitch: {
    transform: 'translateX(30px) !important',
  },
  label: {
    textTransform: 'uppercase',
  },
});

const StyledSwitch = muiStyled(Switch)({
  '&.MuiSwitch-sizeSmall': {
    width: '40px',
    height: '25px',
  },
  '& .Mui-checked': {
    transform: 'translateX(17px) !important',
  },
});

const TeacherEditionList = ({
  links,
  dataBook,
  page,
  booksAllList,
  ebookFlagTeacherEdition,
  setFlagsTeacherEdition,
}) => {
  const location = useLocation();
  const nodeRef = useRef();
  const isProcessingRef = useRef(false);
  const [isVisible, setIsVisible] = useState(false);
  const { updatePopUpAtOnce, checkPopUpAtOnce } = usePopUpAtOnce();
  const { invokeAnswerView, revokeAnswerView, answerView } = useAnswerView();
  const isStoryViewOpen = useStoryViewOpen();

  useEffect(() => {
    if (!links) {
      setIsVisible(false);
    } else if (ebookFlagTeacherEdition && !!links) {
      setIsVisible(true);
    } else if (!ebookFlagTeacherEdition && !!links) {
      setIsVisible(false);
    }
  }, [links, ebookFlagTeacherEdition]);

  useEffect(() => {
    revokeAnswerView();
  }, [location.pathname]);

  const getLink = (link) => {
    try {
      if (typeof link == 'string') {
        return link.match(/\bhttps?:\/\/\S+/gi)[0];
      } else if (typeof link == 'object') {
        return get(link, 'href', '').match(/\bhttps?:\/\/\S+/gi)[0];
      } else {
        return '';
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getHrefTitle = (link) => {
    if (typeof link == 'string') {
      return link;
    } else if (typeof link == 'object') {
      return link.title && link.title.length > 0 ? link.title : link.href;
    } else {
      return '';
    }
  };

  const showPopUpView = () => {
    try {
      const existTeacherEdition =
        find(get(dataBook, 'teacherEdition'), (x) => Number(x.pageId) == page) || {};

      if (
        existTeacherEdition &&
        Object.keys(existTeacherEdition).length > 0 &&
        !existTeacherEdition?.selectedType
      ) {
        const data = {
          resource: existTeacherEdition?.resource,
          sequence: 1,
        };
        revokeAnswerView();
        invokeAnswerView([data]);
        return;
      } else if (
        existTeacherEdition &&
        Object.keys(existTeacherEdition).length > 0 &&
        existTeacherEdition?.selectedType === 'book'
      ) {
        const dataPageTeacherEdition = find(
          booksAllList,
          (x) => x.id == existTeacherEdition?.edBookData?.bookId,
        );
        if (existTeacherEdition?.edBookData?.from && existTeacherEdition?.edBookData?.to) {
          const pageSrc = dataPageTeacherEdition?.pages?.filter((x) => {
            const pageId = Number(x.pageId);
            return (
              pageId >= Number(existTeacherEdition?.edBookData?.from) &&
              pageId <= Number(existTeacherEdition?.edBookData?.to)
            );
          });
          revokeAnswerView();
          invokeAnswerView(pageSrc);
          return;
        }
        const pageSrc = find(
          dataPageTeacherEdition?.pages,
          (x) => x.pageId == existTeacherEdition?.edBookData?.from,
        );
        const data = {
          resource: pageSrc?.resource,
          sequence: 1,
        };
        revokeAnswerView();
        invokeAnswerView([data]);
      } else if (existTeacherEdition?.selectedType === 'uploader') {
        if (existTeacherEdition?.imageData && existTeacherEdition?.imageData?.length > 0) {
          revokeAnswerView();
          invokeAnswerView(existTeacherEdition?.imageData);
          return;
        }
        const data = {
          resource: existTeacherEdition?.resource,
          sequence: 1,
        };
        revokeAnswerView();
        invokeAnswerView([data]);
      }
    } catch (error) {
      captureException(error);
    }
  };



  const handleChange =  async (e) => {
    if (isProcessingRef.current) {
      return;
    }
    
    const isChecked = e.target.checked;
    
    if (isChecked === ebookFlagTeacherEdition) {
      return;
    }
    
    isProcessingRef.current = true;
    
    try {
      if (isChecked) {
        if (checkPopUpAtOnce()) {
          return;
        }
        updatePopUpAtOnce(true);
        setFlagsTeacherEdition(true);
        showPopUpView();
      } else {
        if (!isStoryViewOpen()) updatePopUpAtOnce(false);
        revokeAnswerView();
        setFlagsTeacherEdition(false);
      }
    } finally {
      setTimeout(() => {
        isProcessingRef.current = false;
      }, 100);
    }
  };

  return (
  <SentryWrap>
    <Container className="relative">
      <StyledFormControlLabel
        control={
          <StyledSwitch
            checked={ebookFlagTeacherEdition}
            onChange={handleChange}
            name="viewTeacherEdition"
            color="primary"
            size="small"
          />
        }
        label="Teacher Edition"
      />
      {links && links?.length > 0 && (
        <CSSTransition
          in={isVisible}
          timeout={300}
          classNames="fade"
          unmountOnExit
          nodeRef={nodeRef}
          className="etxActvtyDropDwn"
        >
          <LinkContainer ref={nodeRef}>
            {links.map((link, index) => (
              <LinkItem key={index}>
                <LinksItem href={getLink(link)} target={'_blank'} rel="noopener noreferrer">
                  {getHrefTitle(link)}
                </LinksItem>
              </LinkItem>
            ))}
          </LinkContainer>
        </CSSTransition>
      )}
    </Container>
  </SentryWrap>
  );
};

export default memo(TeacherEditionList);
